import { useIntl } from "~utils/i18n";

export function useLocale() {
  const { locale } = useIntl();

  const isJapanese = locale?.startsWith("ja");

  return {
    locale,
    isJapanese,
  };
}
